/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-12 14:16:50
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-21 19:15:25
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/Components/ProductList/config.ts
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import { EnumLinkProductType1 } from 'src/types/common/salesChannelProduct';

export const filterConfig = (data) => [
  {
    type: 'selection',
    name: getI18nFromGeneral('general.status.type'),
    data: [
      {
        name: getI18nFromGeneral('general.status.singlePhy'),
        key: EnumLinkProductType1.SinglePhysical,
      },
      {
        name: getI18nFromGeneral('general.status.singleSer'),
        key: EnumLinkProductType1.SingleService,
      },
      {
        name: getI18nFromGeneral('general.status.singleGC'),
        key: EnumLinkProductType1.SingleGiftCard,
      },
      {
        name: getI18nFromGeneral('general.status.multiplePhy'),
        key: EnumLinkProductType1.MultiplePhysical,
      },
      {
        name: getI18nFromGeneral('general.status.multipleVir'),
        key: EnumLinkProductType1.MultipleVirtual,
      },
    ],
  },
  {
    type: 'selection',
    name: getI18nFromGeneral('general.status.visibility'),
    data: [
      { key: 'visible', name: getI18nFromGeneral('general.status.visible') },
      {
        key: 'invisible',
        name: getI18nFromGeneral('general.status.invisible'),
      },
    ],
  },
  {
    type: 'selection',
    name: getI18nFromGeneral('general.hOCTitle.tags'),
    data,
  },
];

export const sortConfig = ({ getI18n }) => [
  {
    name: getI18n('general.productname(A-Z)'),
    key: 'productName 1',
  },
  {
    name: getI18n('general.productname(Z-A)'),
    key: 'productName 0',
  },
  {
    name: getI18n('salesChannelProductList.index.modified(oldest)'),
    key: 'modifiedDate 1',
  },
  {
    name: getI18n('salesChannelProductList.index.modified(newest)'),
    key: 'modifiedDate 0',
  },
];
